/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otaupdatetitle2Inputs */



/**
* | output |
* | --- |
* | "Update available" |
*
* @param {Otaupdatetitle2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const otaupdatetitle2 = /** @type {((inputs?: Otaupdatetitle2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otaupdatetitle2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Update available")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hay una actualización")
	return /** @type {LocalizedString} */ ("Есть обновление")
});
export { otaupdatetitle2 as "otaUpdateTitle" }